jQuery.feature_import(
  "js-integrationplatfrom",
  () => require("./integration-platform.tsx"),
  (mod) => mod.feature_js_integrationplatform
);
